export class FwlinkHelper {
    private static cache: { [urlToResolve: string]: string } = {};

    public static ResolveUrl(urlToResolve: string): Promise<string> {
        if (urlToResolve.indexOf('fwlink') < 0) { // if not fwlink, nothing to resolve
            //console.log("NOT FWLINK " + urlToResolve);
            return Promise.resolve(urlToResolve);
        }

        // eslint-disable-next-line security/detect-object-injection
        if (FwlinkHelper.cache[urlToResolve] != null) {
            //console.log("CACHE HIT " + urlToResolve + " " + FwlinkHelper.cache[urlToResolve]);
            // eslint-disable-next-line security/detect-object-injection
            return Promise.resolve(FwlinkHelper.cache[urlToResolve]);
        }

        return new Promise((resolve: (url: string) => void, reject: (error: any) => void) => {
            const request = new XMLHttpRequest();
            request.open("GET", urlToResolve, true);

            request.onload = function(this: XMLHttpRequestEventTarget, ev: Event) {
                if (request.readyState !== 4) {
                    return;
                }

                if ((request.responseURL != null) && (request.responseURL !== "")) {
                    // eslint-disable-next-line security/detect-object-injection
                    FwlinkHelper.cache[urlToResolve] = request.responseURL;
                    resolve(request.responseURL);
                    return;
                }

                resolve(urlToResolve);
            };

            request.onerror = function(this: XMLHttpRequestEventTarget, ev: ProgressEvent) {
                reject((ev as any).error || "Unknown redirect error");
            };

            request.send();
        });
    }
}
